export const COLORS = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_50: '#f8f8f8',
  GRAY_100: '#f0f0f0',
  GRAY_200: '#c5c5c5',
  GRAY_300: '#9ca3af',
  GRAY_400: '#88888E',
  GRAY_500: '#a0aec0',
  GRAY_600: '#444',
  GRAY_700: '#323232',
  GRAY_800: '#292A35',
  GRAY_900: '#1a202c',
  PRIMARY: '#e55b1e',
  PRIMARY_HOVER: '#e65100',
  PRIMARY_DISABLED: '#f0a888',
  ORANGE: '#f97316',
  ORANGE_GRADIENT: '#ff662a',
  ORANGE_BUTTON: '#ff7633',
  BORDER: '#444556',
  RED: '#FF3B30',
  DARK_BLUE: '#111827',
  DARKER_BLUE: '#1f2937',
  TRANSLUCENT_BLACK: '#0000004d',
  TRANSLUCENT_GREY_BG: 'rgba(123, 123, 123,0.1)',
  OPTION_HOVER_BG: 'rgb(221, 77, 20, 0.5)',
  DROPDOWN_INDICATOR: 'rgba(255,255,255,0.4)',
  DROPDOWN_INDICATOR_DISABLED: 'rgba(255,255,255,0.3)',
};